import React, { FC } from 'react';
import TouchableElement from '@components/common/touchableElement';
import { ColorFunction } from '@styles/colors/types';
import { View } from 'react-native';
import { scale as initialScale } from '@components/frame';
import Svg from '@styles/icons/svg';
import { IconConfig, ScaleFunction } from '@components/operatorPanel/interfaces';
import { SimpleOnPress } from '@interfaces/base';

interface OperatorPanelSettingsButtonProps extends SimpleOnPress {
  C: ColorFunction;
  iconConfig: IconConfig;
  scale?: ScaleFunction;
}

const OperatorPanelSettingsButton: FC<OperatorPanelSettingsButtonProps> = ({ onPress, C, iconConfig, scale = initialScale, }) => {
  return (
    <TouchableElement onPress={onPress}>
      {({ pressHoverColor, boxStyle }) => (
        <View
          style={{
            ...boxStyle,
            width: scale(64),
            height: scale(64),
            borderRadius: scale(64),
            justifyContent: 'center',
            alignItems: 'center',
            backgroundColor: C(pressHoverColor('Background/Light/Field lighter')),
            boxShadow: '0px 1.164px 3.491px rgba(0, 0, 0, 0.11), 0px 6.206px 13.964px rgba(0, 0, 0, 0.13)',
          }}
        >
          <Svg {...iconConfig} />
        </View>
      )}
    </TouchableElement>
  );
};

export { OperatorPanelSettingsButton };
